module.exports = __webpack_public_path__ + "static/media/bokeh_lights.86f33ec6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/bokeh_lights.jpg
// module id = 444
// module chunks = 0